import { render, staticRenderFns } from "./BizDirectInvoiceQuery.vue?vue&type=template&id=5dc2df5c&scoped=true&"
import script from "./BizDirectInvoiceQuery.vue?vue&type=script&lang=js&"
export * from "./BizDirectInvoiceQuery.vue?vue&type=script&lang=js&"
import style0 from "./BizDirectInvoiceQuery.vue?vue&type=style&index=0&id=5dc2df5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc2df5c",
  null
  
)

export default component.exports